module.exports = __webpack_public_path__ + "img/server_down.ac157eac.svg";